module.exports = __webpack_public_path__ + "assets/f479583e57778def1dcace7d8e51898a.png";